'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtensionSectionView = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MastheadExtensionSectionView = require('./MastheadExtensionSectionView');

var _MastheadExtensionSectionView2 = _interopRequireDefault(_MastheadExtensionSectionView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MastheadExtensionSectionView = _MastheadExtensionSectionView2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead-extension-section-view')(_MastheadExtensionSectionView2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionSectionView/index.js
 ** module id = 610
 ** module chunks = 1
 **/